/* JUSTPRESS data modules (prototype 2026-10-15, THEME-PROTO-1).
   A module is an inert <template data-jp-mod="<name>" data-p='{params}' data-t='{strings}'> in the page. When
   JPData returns data, the template is cloned, filled and put in its place; when it returns null nothing is shown.
   Demo data (prototype only) marks the module with data-jp-demo so it carries a "Demo" label. */
(function () {
  'use strict';

  function json(s) { try { return JSON.parse(s || '{}'); } catch (_) { return {}; } }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function sub(s, vars) { return String(s || '').replace(/%(\w+)/g, function (m, k) { return vars[k] != null ? vars[k] : m; }); }
  function fmtDate(iso) { var d = new Date(iso); return isNaN(d) ? '' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); }
  function fmtHour(iso) { var d = new Date(iso); return isNaN(d) ? '' : fmtDate(iso) + ', ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }); }
  function img(src, alt, w) { var i = el('img'); i.src = src; i.alt = alt || ''; i.loading = 'lazy'; i.decoding = 'async'; if (w) i.width = w; return i; }
  /* addresses that come from the service: a web address or a path on this shop, never javascript: or data: */
  function safeHref(u) { u = String(u || '').trim(); return /^(https?:\/\/|\/(?!\/)|#)/i.test(u) ? u : '#'; }
  function link(href, cls, text) { var a = el('a', cls, text); a.href = safeHref(href); return a; }

  var R = {};

  /* T06: most saved in a series; the overall list on Community uses the same card (10/15) */
  function rankFill(root, d, t, tpl) {
    var hourly = json(tpl.getAttribute('data-p')).hourly;
    var ol = root.querySelector('[data-slot]');
    d.items.forEach(function (x) {
      var p = x.product || {};
      var li = el('li', 'jp-rank-i');
      var a = link(p.url || '#', 'jp-rank-a');
      var art = el('span', 'jp-rank-art');
      if (p.image) art.appendChild(img(p.image, p.title || '', 480));
      art.appendChild(el('b', 'jp-rank-n', String(x.rank)));
      a.appendChild(art);
      var tx = el('span', 'jp-rank-tx');
      tx.appendChild(el('span', 'jp-rank-t', p.title || ''));
      tx.appendChild(el('small', '', sub(t.saved, { n: x.count })));
      a.appendChild(tx); li.appendChild(a); ol.appendChild(li);
    });
    var note = root.querySelector('[data-slot-note]');
    if (note) note.textContent = sub(t.note, { since: fmtDate(d.tracking_since), asof: hourly ? fmtHour(d.as_of) : fmtDate(d.as_of) });
  }
  R['series-rank'] = { kind: 'series_rank', fill: rankFill };
  R['site-rank'] = { kind: 'site_rank', fill: rankFill };

  /* T07 / T11 / T18: customer photos */
  function photos(root, d, t) {
    var g = root.querySelector('[data-slot]');
    d.items.forEach(function (x) {
      var f = el('figure', 'jp-ugc-i');
      f.appendChild(img(x.image_url, x.alt || '', 480));
      var c = el('figcaption');
      if (x.design && x.design.title) c.appendChild(link(x.design.url, 'jp-ugc-d', x.design.title));
      var meta = [];
      if (x.placement_label) meta.push(x.placement_label);
      if (Number.isInteger(x.reported_day)) meta.push(sub(t.day, { d: x.reported_day }));
      if (meta.length) c.appendChild(el('span', 'jp-ugc-m', meta.join(' · ')));
      var smp = sampleOf(x), who = (x.author && x.author.name) || x.credit_name;
      if (smp) c.appendChild(el('span', 'jp-ugc-m', SMP.by + (smp.real ? ' · ' + SMP.real : '')));
      else if (who) c.appendChild(el('span', 'jp-ugc-m', sub(t.by, { name: who })));
      if (x.incentivized) c.appendChild(el('span', 'jp-ugc-r', t.reward));
      f.appendChild(c); g.appendChild(f);
    });
  }
  R['series-ugc'] = { kind: 'series_ugc', fill: photos };
  R['design-ugc'] = { kind: 'design_ugc', fill: photos };
  R['article-ugc'] = { kind: 'design_ugc', fill: photos };

  /* Start: a series set inside a 36/72 pack (10/15). The block shows only while the chosen pack has room for it
     (capacity ≥ 36); "Add set" puts one 15-space item in the set. ?series_set=<handle> (from the set page's upgrade
     link) moves the set to 36 spaces and adds it. */
  function startSets() {
    var box = document.querySelector('[data-jp-start-sets]');
    if (!box || !window.JPState) return;
    var sel = box.querySelector('select'), btn = box.querySelector('button');
    function capOf(st) { return Number(window.JPState.getPlan(st.plan).capacity) || 15; }
    function sync() { box.hidden = capOf(window.JPState.read()) < 36; }
    function add(handle) {
      var o = sel.querySelector('option[value="' + handle + '"]'); if (!o) return false;
      var style = o.getAttribute('data-style') || '';
      return window.JPState.update(function (next) {
        if (capOf(next) < 36) next.plan = 'core';
        var id = 'series-set-' + handle;
        var item = { id: id, productHandle: o.getAttribute('data-set') || '', designCode: id, title: sub(box.getAttribute('data-t-title'), { style: style }),
          image: o.getAttribute('data-image') || '', sourceType: 'library', type: 'image', editorStatus: 'ready',
          sizeId: 'series-set-15', sizeLabel: box.getAttribute('data-t-size') || '15', spaces: 15, quantity: 1 };
        var i = next.items.findIndex(function (x) { return x.id === id; });
        if (i > -1) next.items[i].quantity = Math.min(99, (Number(next.items[i].quantity) || 1) + 1); else next.items.push(item);
        next.currentItemId = id;
        return next;
      }, 'series-set-add');
    }
    btn.addEventListener('click', function () { add(sel.value); });
    document.addEventListener('justpress:state-change', sync);
    var q = new URLSearchParams(location.search).get('series_set');
    if (q && add(q)) { sel.value = q; history.replaceState(null, '', location.pathname); }
    sync();
  }

  /* T13: what the set costs with this design (B: spaces → smallest pack that fits, shipping extra). Uses the
     packs the store sells (JPState plans); shown once the set has something in it. */
  function costLine() {
    var el = document.querySelector('[data-jp-cost]');
    if (!el || !window.JPState) return;
    function paint() {
      var st = window.JPState.read(), items = st.items || [];
      if (!items.length) { el.hidden = true; return; }
      var n = window.JPState.totalRequiredSpaces(items);
      var pid = el.getAttribute('data-pid');
      var here = items.some(function (x) { return String(x.productId) === pid; });
      if (!here) n += Number(el.getAttribute('data-sp')) || 0;
      var plans = ['starter', 'core', 'large'].map(function (id) { return window.JPState.getPlan(id); }).filter(function (p) { return p && p.available !== false && p.capacity; });
      plans.sort(function (a, b) { return a.capacity - b.capacity; });
      var fit = plans.filter(function (p) { return p.capacity >= n; })[0];
      if (!plans.length) { el.hidden = true; return; }
      if (!fit) { el.textContent = sub(el.getAttribute('data-t-over'), { n: n }); el.hidden = false; return; }
      if (!fit.priceLabel) { el.hidden = true; return; }
      var name = String(fit.name || '').toLowerCase().replace(/^./, function (c) { return c.toUpperCase(); });
      el.textContent = sub(el.getAttribute('data-t'), { n: n, pack: name, cap: fit.capacity, price: fit.priceLabel });
      el.hidden = false;
    }
    document.addEventListener('justpress:state-change', paint);
    paint();
  }

  /* T02 / T29: "has photos" marks and filter on any design grid */
  R['ugc-filter'] = { kind: 'ugc_index', fill: function (root, d, t, tpl) {
    var ids = {}; d.product_ids.forEach(function (x) { ids[String(x)] = 1; });
    var wrap = tpl.parentNode, grid = wrap.querySelector('[data-jp-p0-grid]') || document.querySelector('[data-jp-p0-grid]');
    var hit = 0;
    /* library cards (.pin) and the search fallback cards ([data-jp-p0-card] with data-product-id, 10/16) */
    function mark() {
      hit = 0;
      (grid ? grid.querySelectorAll('.pin, [data-jp-p0-card][data-product-id]') : []).forEach(function (pin) {
        var b = pin.hasAttribute('data-product-id') ? pin : pin.querySelector('[data-product-id]');
        if (b && ids[b.getAttribute('data-product-id')]) { pin.setAttribute('data-jp-has-ugc', ''); var ph = pin.querySelector('.ph, .jp-library-card__media'); if (ph) ph.setAttribute('data-ugc-label', t.mark); hit++; }
      });
      root.hidden = !hit;
    }
    mark();
    var chip = root.querySelector('[data-slot]'); chip.textContent = t.chip;
    chip.addEventListener('click', function () { var on = chip.getAttribute('aria-pressed') !== 'true'; chip.setAttribute('aria-pressed', on); chip.classList.toggle('on', on); if (grid) grid.classList.toggle('jp-only-ugc', on); });
    if (grid && window.MutationObserver) new MutationObserver(mark).observe(grid, { childList: true });
  } };

  /* Community photo wall (10/15): browsing first. Masonry in each photo's own proportions (columns by width), more
     photos load as the end comes into view, a tap opens the photo large (with its design, place, day, reward
     disclosure, Add to set and more photos of the same design); #p-<key> links straight to one photo. */
  /* a srcset only when it offers a choice (one candidate adds nothing and a wrong w only mis-sizes the pick) */
  function srcsetOf(x) { var c = (x.image_srcset || []).filter(function (s) { return s && s.url && Number(s.w) > 0; }); return c.length > 1 ? c.map(function (s) { return s.url + ' ' + s.w + 'w'; }).join(', ') : ''; }
  /* eager: the first screen of the wall loads at once (lazy pictures there wait for layout and scroll checks).
     A picture that fails with its srcset is tried once more from image_url alone; one that still fails takes its
     card off the wall (no empty grey boxes). */
  function photoImg(x, sizes, eager) {
    var i = img(x.image_url, x.alt || '');
    if (eager) i.loading = 'eager';
    var ss = srcsetOf(x); if (ss) { i.sizes = sizes; i.srcset = ss; }
    if (x.image_w && x.image_h) { i.width = x.image_w; i.height = x.image_h; }
    i.addEventListener('error', function () {
      if (i.srcset) { i.removeAttribute('srcset'); i.removeAttribute('sizes'); i.src = x.image_url; return; }
      var card = i.closest('.jp-cm-i'); if (card) card.hidden = true;
    });
    return i;
  }
  function setAdd(dz, t, cls, label) {
    var a = link(dz.url, cls, label);
    a.setAttribute('data-jp-set-add', ''); a.setAttribute('data-id', dz.id); a.setAttribute('data-handle', dz.handle);
    a.setAttribute('data-title', dz.title || ''); a.setAttribute('data-image', dz.image || ''); a.setAttribute('data-size', dz.size_label || '');
    a.setAttribute('data-code', dz.code || ''); a.setAttribute('data-style', dz.style || '');
    a.setAttribute('aria-label', t.add + ': ' + (dz.title || ''));
    return a;
  }
  /* 10/15 community step 1: every photo is a post. source "library" (one of our designs: Add to set) or "custom" (the
     customer's own design: Make your own); author, text, "From a JUSTPRESS order"; likes (count shown from LIKE_MIN);
     comments (signed in to write, our replies marked and first, report on posts and comments). */
  var LIKE_MIN = 5, FOLLOW_MIN = 10, VIEW_MIN = 20;
  /* post views (10/16): one per post per browser/device a day, never the author's own; public from VIEW_MIN, the author
     always sees their own. The browser id is the same random one the save count uses. */
  function fmtN(n) { return n >= 1000 ? (Math.floor(n / 100) / 10).toFixed(1).replace(/\.0$/, '') + 'k' : String(n); }
  function viewDevice() { try { return localStorage.getItem('justpress:saved-count:device:v1') || ''; } catch (_) { return ''; } }
  function sendView(x) {
    if (x.mine || x.__viewed) return; x.__viewed = true;
    var day = new Date().toISOString().slice(0, 10), k = 'jp-view:' + x.public_key;
    try { if (localStorage.getItem(k) === day) return; localStorage.setItem(k, day); } catch (_) {}
    x.view_count = (Number(x.view_count) || 0) + 1;
    if (window.JPProto && window.JPProto.__view) return;
    if (cfg.pub) fetch(cfg.pub.replace(/\/$/, '') + '/v1/posts/' + encodeURIComponent(x.public_key) + '/view', { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ device_id: viewDevice() }) }).catch(function () {});
  }
  /* avatars: the customer's photo when they added one, otherwise their first letter on a colour picked from their key */
  var AV_TINTS = ['#E9E4F5', '#E2EEF7', '#E5F2E6', '#F7EADF', '#F5E3E8', '#ECEAE4'];
  function avatar(au, size, official) {
    var w = el('span', 'jp-av' + (official ? ' jp-av-off' : '')); w.style.width = w.style.height = size + 'px';
    if (official) { w.innerHTML = '<svg viewBox="0 0 548 779" aria-hidden="true"><path d="M274 0C190 100 0 330 0 505a274 274 0 0 0 548 0C548 330 358 100 274 0Z"/></svg>'; return w; }
    au = au || {};
    if (au.avatar_url) { var i = img(au.avatar_url, '', size * 2); w.appendChild(i); return w; }
    var n = String(au.name || '?').replace(/^Demo · /, ''), k = String(au.key || n), h = 0;
    for (var j = 0; j < k.length; j++) h = (h * 31 + k.charCodeAt(j)) >>> 0;
    w.style.background = AV_TINTS[h % AV_TINTS.length]; w.style.fontSize = Math.round(size * 0.42) + 'px';
    w.textContent = n.charAt(0).toUpperCase(); w.setAttribute('aria-hidden', 'true');
    return w;
  }
  function isCustom(x) { return x.source === 'custom'; }
  /* 11/02: samples by JUSTPRESS (official posts with sample fields) are ours and say so, as the page's own sample
     wall does: "Sample by JUSTPRESS", the sample's title, its kind, place, tested wear and "Real photo" when it is
     one; never an avatar or a Custom badge. Older items carry the fields only in their caption:
     "Sample by JUSTPRESS · Sample: <title>\n<kind> design · <place> · tested wear X–Y days[ · Real photo]". */
  var SMP = { by: 'Sample by JUSTPRESS', real: 'Real photo', title: 'Sample: %t', wear: '%r days tested wear', wear_k: 'Tested wear', days: '%r days',
    worn: 'Worn on', made: 'Made as', topics: 'Topics', text_cta: 'Write your own', photo_cta: 'Upload your photo', library_cta: 'Browse the Library' };
  var SMP_KIND = { 'Text': 'Text design', 'Their photo': 'Photo design', 'Photo': 'Photo design', 'Library': 'Library design' };
  var SMP_CLS = { 'Text design': 'kt', 'Photo design': 'kp', 'Library design': 'kl' };
  /* topic chips, in the order of the page's sample wall; the keys are the page's #topic addresses */
  var TOPICS = [['dates', 'Dates'], ['names', 'Names'], ['pets', 'Pets'], ['memory', 'In memory'], ['matching', 'Matching'], ['words', 'Words'], ['library', 'Library designs']];
  function sampleOf(x) {
    if (!x || !(x.official || x.sample)) return null;
    if (x.__smp !== undefined) return x.__smp;
    var lines = String(x.caption || '').split('\n'), l1 = lines[0] || '', l2 = lines[1] || '';
    var title = String(x.sample_title || (/Sample:\s*(.+)$/.exec(l1) || [])[1] || '').trim();
    var kind = SMP_KIND[x.sample_kind] || (/^(Text|Photo|Library) design\b/.exec(l2) || [])[0] || '';
    var wear = String(x.tested_wear_range || (/tested wear\s+(\d+\s*[–-]\s*\d+)/.exec(l2) || [])[1] || '').trim();
    x.__smp = title ? { title: title, kind: kind, cls: SMP_CLS[kind] || 'kl', wear: wear, real: /·\s*Real photo\s*$/.test(l2), topic: String(x.sample_topic || '') } : null;
    return x.__smp;
  }
  function topicKey(x) {
    var s = sampleOf(x);
    if (s && s.topic) { var hit = TOPICS.filter(function (k) { return k[1] === s.topic; })[0]; return hit ? hit[0] : s.topic.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    return isCustom(x) ? '' : 'library';
  }
  R['photos-feed'] = { kind: 'ugc_feed', fill: function (root, d, t, tpl) {
    var P = json(tpl.getAttribute('data-p')), me = !!(cfg && cfg.customer), kind = '', follows = {}, followsReady = null;
    function loadFollows() {
      if (!me) return Promise.resolve(null);
      if (!followsReady) followsReady = window.JPData.get('following', {}).then(function (fd) { (fd && fd.follows || []).forEach(function (k) { follows[k] = 1; }); return fd; });
      return followsReady;
    }
    function followBtn(key, name) {
      var b = el('button', 'jp-cm-follow'); b.type = 'button';
      function paint() { var on = !!follows[key]; b.textContent = on ? t.following_btn : t.follow; b.setAttribute('aria-pressed', String(on)); b.classList.toggle('on', on); }
      b.addEventListener('click', function () {
        if (!me) { var a = signLink(t.sign_follow); b.replaceWith(a); return; }
        var on = !follows[key]; if (on) follows[key] = 1; else delete follows[key]; paint();
        document.dispatchEvent(new CustomEvent('justpress:follow', { detail: { key: key, on: on } }));
        if (window.JPProto && window.JPProto.__follow) { window.JPProto.__follow(key, on); return; }
        if (cfg.me) fetch(cfg.me.replace(/\/$/, '') + '/v1/me/follows/' + encodeURIComponent(key), { method: on ? 'PUT' : 'DELETE', credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(); }).catch(function () { if (on) delete follows[key]; else follows[key] = 1; paint(); });
      });
      paint(); loadFollows().then(paint);
      return b;
    }
    function authorLink(x, cls) {
      var au = x.author || {}, n = au.name || x.credit_name || '';
      var a = el(au.key ? 'a' : 'span', cls); a.appendChild(avatar(au, 36)); a.appendChild(el('span', 'jp-cm-aunm', n));
      if (au.key) { a.href = '#u-' + au.key; a.addEventListener('click', function (e) { e.preventDefault(); showProfile(au.key, true); }); }
      return a;
    }
    var empty = document.querySelector('[data-jp-photos-empty]'); if (empty) empty.hidden = true;
    var wall = root.querySelector('[data-slot]'), bar = root.querySelector('[data-slot-f]'), more = root.querySelector('[data-slot-more]'), none = root.querySelector('[data-slot-none]'), end = root.querySelector('[data-slot-end]');
    var all = d.items.slice(), cursor = d.next_cursor || null, shown = 0, PAGE = 18, where = '', series = '', topic = '', topicRow = null, cols = [], heights = [], loading = false;
    function match(x) { return (!kind || (kind === 'custom') === isCustom(x)) && (!where || x.placement_label === where) && (!series || (x.design && x.design.series && x.design.series.handle === series)) && (!topic || topicKey(x) === topic); }
    function ncols() { var w = wall.clientWidth || window.innerWidth; return w >= 1100 ? 5 : w >= 760 ? 4 : w >= 560 ? 3 : 2; }
    function build() {
      wall.textContent = ''; cols = []; heights = [];
      for (var i = 0, n = ncols(); i < n; i++) { var c = el('div', 'jp-cm-col'); wall.appendChild(c); cols.push(c); heights.push(0); }
    }
    /* a sample's card, as the page's own sample wall: kind and place, title, tested wear, "Sample by JUSTPRESS" */
    function sampleCaption(x, smp) {
      var dz = x.design || {}, c = el('figcaption', 'jp-cm-sc'), mk = el('span', 'jp-cm-mk mk');
      if (smp.kind) mk.appendChild(el('i', smp.cls, smp.kind));
      if (x.placement_label) mk.appendChild(document.createTextNode(x.placement_label));
      if (mk.childNodes.length) c.appendChild(mk);
      c.appendChild(dz.url ? link(dz.url, 'jp-cm-d', smp.title) : el('span', 'jp-cm-d', smp.title));
      if (smp.wear) c.appendChild(el('span', 'jp-cm-dy', sub(SMP.wear, { r: smp.wear })));
      c.appendChild(el('span', 'jp-cm-smp', SMP.by + (smp.real ? ' · ' + SMP.real : '')));
      return c;
    }
    function tile(x, eager) {
      var dz = x.design || {}, cu = isCustom(x), smp = sampleOf(x), name = smp ? sub(SMP.title, { t: smp.title }) : cu ? t.custom_title : (dz.title || '');
      var f = el('figure', 'jp-cm-i' + (smp ? ' jp-cm-sample' : '')); f.setAttribute('data-jp-set-host', ''); f.id = 'p-' + x.public_key;
      var open = el('a', 'jp-cm-open'); open.href = safeHref(x.page_url || '#p-' + x.public_key); open.setAttribute('aria-label', sub(t.open, { title: name }));
      open.appendChild(photoImg(x, '(min-width: 1100px) 19vw, (min-width: 760px) 24vw, (min-width: 560px) 32vw, 48vw', eager));
      if (x.incentivized) open.appendChild(el('span', 'jp-cm-tag', t.reward_tag));
      if (smp) { open.addEventListener('click', function (e) { e.preventDefault(); show(x, true); }); f.appendChild(open); f.appendChild(sampleCaption(x, smp)); return f; }
      if (x.author && (x.author.name || x.author.avatar_url)) {
        /* the wall shows the avatar only; its text alternative is the nickname (control centre 8.1) */
        var tav = avatar(x.author, 26), nick = String(x.author.name || '').replace(/^Demo · /, ''); tav.classList.add('jp-cm-tav');
        var tim = tav.querySelector('img'); if (tim) tim.alt = nick; else if (nick) { tav.removeAttribute('aria-hidden'); tav.setAttribute('role', 'img'); tav.setAttribute('aria-label', nick); }
        open.appendChild(tav);
      }
      open.addEventListener('click', function (e) { e.preventDefault(); show(x, true); });
      f.appendChild(open);
      var c = el('figcaption');
      if (cu) { c.appendChild(el('span', 'jp-cm-src', t.custom)); c.appendChild(el('span', 'jp-cm-d', t.custom_title)); }
      else c.appendChild(link(dz.url, 'jp-cm-d', dz.title || ''));
      if ((x.updates || []).length) open.appendChild(el('span', 'jp-cm-tag jp-cm-diary', sub(t.diary_tag, { n: x.updates.length + 1 })));
      if (x.placement_label) c.appendChild(el('span', 'jp-cm-m', x.placement_label));
      f.appendChild(c);
      return f;
    }
    function place(x, eager) {
      var k = 0; for (var i = 1; i < heights.length; i++) if (heights[i] < heights[k] - 1) k = i;
      cols[k].appendChild(tile(x, eager));
      heights[k] += (x.image_w && x.image_h ? x.image_h / x.image_w : 1.25) + 0.18;
    }
    function draw(reset) {
      if (reset) { build(); shown = 0; }
      var list = all.filter(match), next = list.slice(shown, shown + PAGE), first = shown === 0;
      next.forEach(function (x, i) { place(x, first && i < cols.length * 2); }); shown += next.length;
      /* the page's "Samples by JUSTPRESS …" line stays only while every post is one of ours */
      if (all.every(sampleOf)) root.setAttribute('data-samples-only', ''); else root.removeAttribute('data-samples-only');
      none.hidden = list.length > 0;
      more.hidden = !(shown < list.length || cursor) || !!io;
    }
    function loadMore() {
      if (loading) return;
      if (shown < all.filter(match).length) { draw(false); return; }
      if (!cursor) return;
      loading = true;
      window.JPData.get('ugc_feed', { cursor: cursor }).then(function (d2) {
        loading = false;
        if (!d2) { cursor = null; draw(false); return; }
        all = all.concat(d2.items); cursor = d2.next_cursor || null; chips(); draw(false);
      });
    }
    /* samples carry a topic (Dates, Names, Pets …): then the wall filters by topic, as the page's sample wall, and the
       row is the page's topic chips (the page moves it into its bar under the tabs); otherwise by type, place, series */
    function topicChips() {
      var n = {}, keys = [], label = {};
      all.forEach(function (x) { var k = topicKey(x); if (!k) return; if (!n[k]) { n[k] = 0; keys.push(k); label[k] = (sampleOf(x) || {}).topic || ''; } n[k]++; });
      var order = TOPICS.map(function (k) { return k[0]; });
      keys.sort(function (a, b) { var i = order.indexOf(a), j = order.indexOf(b); return (i < 0 ? 99 : i) - (j < 0 ? 99 : j); });
      if (!topicRow) {
        topicRow = el('div', 'topics jp-cm-topics'); topicRow.setAttribute('role', 'group'); topicRow.setAttribute('aria-label', SMP.topics); topicRow.setAttribute('data-jp-feed-topics', '');
        topicRow.addEventListener('click', function (e) {
          var b = e.target.closest('[data-t]'); if (!b) return;
          topic = b.getAttribute('data-t') === 'all' ? '' : b.getAttribute('data-t'); paintTopics(); draw(true);
          try { history.replaceState(history.state, '', topic ? '#' + topic : location.pathname + location.search); } catch (_) {}
        });
      }
      topicRow.textContent = '';
      [['all', t.all, all.length]].concat(keys.map(function (k) { var o = TOPICS.filter(function (x) { return x[0] === k; })[0]; return [k, o ? o[1] : label[k], n[k]]; })).forEach(function (o) {
        var b = el('button', '', o[1] + ' '); b.type = 'button'; b.setAttribute('data-t', o[0]); b.appendChild(el('span', '', String(o[2]))); topicRow.appendChild(b);
      });
      paintTopics();
      if (!topicRow.parentNode) bar.appendChild(topicRow);
    }
    function paintTopics() { if (topicRow) topicRow.querySelectorAll('[data-t]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-t') === (topic || 'all'))); }); }
    function chips() {
      if (all.some(function (x) { var s = sampleOf(x); return s && s.topic; })) { kind = ''; where = ''; series = ''; topicChips(); return; }
      bar.textContent = '';
      var places = [], ser = [], seen = {}, nLib = 0, nCus = 0;
      all.forEach(function (x) {
        if (isCustom(x)) nCus++; else nLib++;
        if (x.placement_label && !seen['p' + x.placement_label]) { seen['p' + x.placement_label] = 1; places.push(x.placement_label); }
        var s = x.design && x.design.series; if (s && s.handle && !seen['s' + s.handle]) { seen['s' + s.handle] = 1; ser.push(s); }
      });
      if (nLib && nCus) {
        var seg = el('div', 'jp-cm-type'); seg.setAttribute('role', 'group');
        [['', t.type_all], ['library', t.library], ['custom', t.custom]].forEach(function (o) {
          var b = el('button', '', o[1]); b.type = 'button'; b.setAttribute('aria-pressed', String(kind === o[0]));
          b.addEventListener('click', function () { kind = o[0]; if (kind === 'custom') series = ''; chips(); draw(true); });
          seg.appendChild(b);
        });
        bar.appendChild(seg);
      }
      var row = el('div', 'jp-photos-chips'); row.setAttribute('role', 'group'); row.setAttribute('aria-label', t.where);
      if (places.length > 1) {
        [''].concat(places).forEach(function (p) {
          var b = el('button', 'chip' + (p === where ? ' on' : ''), p || t.all); b.type = 'button'; b.setAttribute('aria-pressed', String(p === where));
          b.addEventListener('click', function () { where = p; chips(); draw(true); });
          row.appendChild(b);
        });
      }
      if (ser.length > 1 && kind !== 'custom') {
        var lab = el('label', 'jp-photos-sel'); lab.appendChild(el('span', 'vh', t.series));
        var s = el('select'); var o0 = el('option', '', t.all_series); o0.value = ''; s.appendChild(o0);
        ser.forEach(function (x) { var o = el('option', '', x.title || x.handle); o.value = x.handle; if (x.handle === series) o.selected = true; s.appendChild(o); });
        s.addEventListener('change', function () { series = s.value; draw(true); });
        lab.appendChild(s); row.insertBefore(lab, row.firstChild);
      }
      if (row.childNodes.length) bar.appendChild(row);
    }
    /* the large view */
    /* §12.7: a post with its own page shows that page's address while open (the dialog stays); closing returns to
       Community. Old #p-<key> links open the post and switch the address to its page. */
    var dlg = el('dialog', 'jp-cm-dlg'), lastHash = '', home = location.pathname + location.search;
    function addr(u) { try { history.replaceState(null, '', u); } catch (_) {} }
    dlg.setAttribute('aria-label', '');
    document.body.appendChild(dlg);
    function signLink(text) { var a = link(P.acct || '/account', 'lnk', text); a.setAttribute('data-jp-account-return', ''); return a; }
    function likeBox(x) {
      var box = el('p', 'jp-cm-like');
      var b = el('button', 'jp-cm-heart' + (x.liked ? ' on' : '')); b.type = 'button'; b.setAttribute('aria-pressed', String(!!x.liked)); b.setAttribute('aria-label', t.like);
      b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';
      var n = el('span', 'jp-cm-likes');
      function paint() { var c = Number(x.like_count) || 0; n.textContent = c >= LIKE_MIN ? sub(t.likes, { n: c }) : ''; b.classList.toggle('on', !!x.liked); b.setAttribute('aria-pressed', String(!!x.liked)); }
      b.addEventListener('click', function () {
        if (!me) { box.appendChild(signLink(t.sign_like)); b.disabled = true; return; }
        var was = { liked: !!x.liked, n: Number(x.like_count) || 0 };
        x.liked = !was.liked; x.like_count = Math.max(0, was.n + (x.liked ? 1 : -1)); paint();
        if (window.JPProto && window.JPProto.__like) return;
        if (cfg.me) fetch(cfg.me.replace(/\/$/, '') + '/v1/me/posts/' + encodeURIComponent(x.public_key) + '/like', { method: x.liked ? 'PUT' : 'DELETE', credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json().catch(function () { return {}; }); })
          .then(function (j) { if (j && typeof j.liked === 'boolean') x.liked = j.liked; if (j && Number.isInteger(j.like_count) && j.like_count >= 0) x.like_count = j.like_count; paint(); },
                function () { x.liked = was.liked; x.like_count = was.n; paint(); });
      });
      box.appendChild(b); box.appendChild(n); paint();
      var vc = Number(x.view_count) || 0;
      if (vc >= VIEW_MIN || x.mine) { var v = el('span', 'jp-cm-views'); v.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/></svg>'; v.appendChild(document.createTextNode(sub(vc === 1 ? t.view_1 : t.views, { n: fmtN(vc) }) + (x.mine && vc < VIEW_MIN ? ' · ' + t.views_only_you : ''))); box.appendChild(v); }
      return box;
    }
    function comments(x, wrap) {
      wrap.appendChild(el('h3', 'jp-cm-ch', t.comments_h));
      var list = el('ul', 'jp-cm-cl'); wrap.appendChild(list);
      function item(c) {
        var li = el('li', 'jp-cm-c' + (c.official ? ' jp-cm-off' : ''));
        var hd = el('p', 'jp-cm-chd'); hd.appendChild(avatar({ name: c.author, key: c.author_key, avatar_url: c.author_avatar }, 26, c.official)); hd.appendChild(el('b', '', c.official ? t.official : (c.author || ''))); if (c.created_at) hd.appendChild(el('small', '', fmtDate(c.created_at)));
        li.appendChild(hd); li.appendChild(el('p', 'jp-cm-ct', c.text || ''));
        return li;
      }
      window.JPData.get('post_comments', { key: x.public_key }).then(function (cd) {
        var cs = cd && cd.items ? cd.items.slice() : [];
        cs.sort(function (a, b) { return (b.official ? 1 : 0) - (a.official ? 1 : 0); });
        if (!cs.length) list.appendChild(el('li', 'jp-cm-none', t.no_comments));
        cs.forEach(function (c) { list.appendChild(item(c)); });
      });
      if (!me) { var p = el('p', 'jp-cm-sign'); p.appendChild(signLink(t.sign_comment)); wrap.appendChild(p); return; }
      var f = el('form', 'jp-cm-form'); f.noValidate = true;
      var lab = el('label', 'vh', t.comment_ph); var ta = el('textarea'); ta.rows = 2; ta.maxLength = 500; ta.placeholder = t.comment_ph; ta.id = 'jp-cm-ta-' + x.public_key; lab.htmlFor = ta.id;
      var row = el('div', 'jp-cm-frow'); var send = el('button', 'cta', t.comment_send); send.type = 'submit';
      var st = el('p', 'jp-cm-st cap2', t.comment_rules); st.setAttribute('role', 'status');
      f.appendChild(lab); f.appendChild(ta); row.appendChild(st); row.appendChild(send); f.appendChild(row);
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = ta.value.trim(); if (!v) return;
        if (/(https?:\/\/|www\.)/i.test(v)) { st.textContent = t.no_links; return; }
        if (window.JPProto && window.JPProto.__comment) { list.querySelectorAll('.jp-cm-none').forEach(function (n) { n.remove(); }); list.appendChild(item({ author: t.you, text: v, created_at: new Date().toISOString() })); ta.value = ''; st.textContent = window.JPProto.__comment(); return; }
        if (!cfg.me) return;
        send.disabled = true;
        fetch(cfg.me.replace(/\/$/, '') + '/v1/me/posts/' + encodeURIComponent(x.public_key) + '/comments', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ text: v }) })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json().catch(function () { return {}; }); })
          .then(function (c) { list.querySelectorAll('.jp-cm-none').forEach(function (n) { n.remove(); }); list.appendChild(item({ author: (c && c.author) || t.you, text: v, created_at: (c && c.created_at) || new Date().toISOString() })); ta.value = ''; st.textContent = t.comment_rules; })
          .catch(function () { st.textContent = t.comment_error; }).then(function () { send.disabled = false; });
      });
      wrap.appendChild(f);
    }
    /* step 2: wear diary - the same tattoo on later days; the author can add a day */
    function diary(x, fig, info) {
      var ups = (x.updates || []).slice().sort(function (a, b) { return a.day - b.day; });
      if (!ups.length && !x.mine) return;
      var box = el('div', 'jp-cm-diary-box');
      box.appendChild(el('p', 'jp-cm-sameh', t.diary_h));
      var row = el('div', 'jp-cm-days'); box.appendChild(row);
      var note = el('p', 'jp-cm-meta'); box.appendChild(note);
      var steps = [{ day: x.reported_day, image_url: x.image_url, image_srcset: x.image_srcset, image_w: x.image_w, image_h: x.image_h, caption: '' }].concat(ups);
      function pick(i) {
        var u = steps[i]; fig.textContent = ''; fig.appendChild(photoImg(Object.assign({ alt: x.alt }, u), '(min-width: 900px) 560px, 100vw'));
        row.querySelectorAll('button').forEach(function (b, k) { b.setAttribute('aria-pressed', String(k === i)); });
        note.textContent = u.caption || '';
      }
      function chips() {
        row.textContent = '';
        steps.forEach(function (u, i) { var b = el('button', 'jp-cm-day', Number.isInteger(u.day) ? sub(t.diary_day, { d: u.day }) : t.diary_first); b.type = 'button'; b.setAttribute('aria-pressed', 'false'); b.addEventListener('click', function () { pick(i); }); row.appendChild(b); });
      }
      chips(); row.firstChild && row.firstChild.setAttribute('aria-pressed', 'true');
      if (x.mine) {
        var add = el('button', 'pbtn jp-cm-addday', t.diary_add); add.type = 'button';
        add.addEventListener('click', function () {
          add.hidden = true;
          var f = el('form', 'jp-cm-dform'); f.noValidate = true;
          var l1 = el('label', 'jp-shf-f'); l1.appendChild(el('span', '', t.diary_which)); var dn = el('input'); dn.type = 'number'; dn.min = '1'; dn.max = '30'; dn.required = true; dn.value = String((steps[steps.length - 1].day || 1) + 7); l1.appendChild(dn); f.appendChild(l1);
          var l2 = el('label', 'jp-shf-f'); l2.appendChild(el('span', '', t.diary_photo)); var fi = el('input'); fi.type = 'file'; fi.accept = 'image/*'; l2.appendChild(fi); f.appendChild(l2);
          var l3 = el('label', 'jp-shf-f'); l3.appendChild(el('span', '', t.diary_note)); var tx = el('textarea'); tx.rows = 2; tx.maxLength = 300; l3.appendChild(tx); f.appendChild(l3);
          var st = el('p', 'cap2'); st.setAttribute('role', 'status');
          var go = el('button', 'cta', t.diary_post); go.type = 'submit'; f.appendChild(go); f.appendChild(st);
          f.addEventListener('submit', function (e) {
            e.preventDefault();
            var day = parseInt(dn.value, 10); if (!(day >= 1)) return;
            var u = { day: day, image_url: x.image_url, image_srcset: x.image_srcset, image_w: x.image_w, image_h: x.image_h, caption: tx.value.trim() };
            /* control centre 9.1: a later day is checked like any photo and only shows once approved */
            function sent() { f.remove(); box.appendChild(el('p', 'cap2 jp-cm-pend', t.diary_pending)); }
            if (window.JPProto && window.JPProto.__update) { window.JPProto.__update(); sent(); return; }
            if (!cfg.me) return;
            var fd = new FormData(f); fd.append('day', String(day));
            go.disabled = true;
            fetch(cfg.me.replace(/\/$/, '') + '/v1/me/posts/' + encodeURIComponent(x.public_key) + '/updates', { method: 'POST', credentials: 'same-origin', body: fd })
              .then(function (r) { if (!r.ok) throw new Error(); sent(); })
              .catch(function () { st.textContent = t.comment_error; }).then(function () { go.disabled = false; });
          });
          box.appendChild(f);
        });
        box.appendChild(add);
      }
      info.appendChild(box);
    }
    /* step 3: the author of a custom design can offer it to the Library (rights confirmed, credited, a share of sales;
       terms agreed before it goes on sale). States: submitted, listed, declined. */
    function offer(x, info) {
      var box = el('div', 'jp-cm-offer');
      var stt = { submitted: t.offer_st_submitted, listed: t.offer_st_listed, declined: t.offer_st_declined }[x.offer_state];
      if (stt) { box.appendChild(el('p', 'jp-cm-ost', stt)); info.appendChild(box); return; }
      var b = el('button', 'pbtn', t.offer); b.type = 'button'; box.appendChild(b);
      b.addEventListener('click', function () {
        b.hidden = true;
        var f = el('form', 'jp-cm-oform'); f.noValidate = true;
        f.appendChild(el('b', '', t.offer_h)); f.appendChild(el('p', 'cap2', t.offer_note));
        function tick(txt) { var l = el('label', 'jp-cm-tick'); var c = el('input'); c.type = 'checkbox'; l.appendChild(c); l.appendChild(el('span', '', txt)); f.appendChild(l); return c; }
        var c1 = tick(t.offer_own), c2 = tick(t.offer_ok);
        var ln = el('label', 'jp-shf-f'); ln.appendChild(el('span', '', t.offer_name)); var nm = el('input'); nm.type = 'text'; nm.maxLength = 40; ln.appendChild(nm); f.appendChild(ln);
        var st = el('p', 'cap2'); st.setAttribute('role', 'status');
        var go = el('button', 'cta', t.offer_send); go.type = 'submit'; f.appendChild(go); f.appendChild(st);
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!c1.checked || !c2.checked) { st.textContent = t.offer_need; return; }
          function done() { x.offer_state = 'submitted'; f.remove(); box.appendChild(el('p', 'jp-cm-ost', t.offer_st_submitted)); box.appendChild(el('p', 'cap2', t.offer_sent)); }
          if (window.JPProto && window.JPProto.__offer) { window.JPProto.__offer(); done(); return; }
          if (!cfg.me) return;
          go.disabled = true;
          fetch(cfg.me.replace(/\/$/, '') + '/v1/me/posts/' + encodeURIComponent(x.public_key) + '/offer', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ rights_confirmed: true, listing_agreed: true, name: nm.value.trim() }) })
            .then(function (r) { if (!r.ok) throw new Error(); done(); }).catch(function () { st.textContent = t.comment_error; go.disabled = false; });
        });
        box.appendChild(f);
      });
      info.appendChild(box);
    }
    /* step 2: a public profile (only when its owner turned it on): name, posts, Follow */
    function showProfile(key, push) {
      window.JPData.get('profile', { key: key }).then(function (pf) {
        if (!pf) return;
        dlg.textContent = ''; dlg.classList.add('jp-cm-prof');
        var x0 = el('button', 'jp-cm-x'); x0.type = 'button'; x0.setAttribute('aria-label', t.close); x0.textContent = '×'; x0.addEventListener('click', close); dlg.appendChild(x0);
        var hd = el('div', 'jp-cm-ph');
        hd.appendChild(avatar({ name: pf.name, key: pf.key, avatar_url: pf.avatar_url }, 64));
        var tx = el('div', 'jp-cm-pt'); tx.appendChild(el('h2', '', pf.name || ''));
        var bits = []; if (pf.kind === 'designer' || (pf.designs || []).length) bits.push(t.designer); bits.push(sub(t.posts_n, { n: (pf.posts || []).length }));
        if (Number(pf.follower_count) >= FOLLOW_MIN) bits.push(sub(t.followers_n, { n: pf.follower_count }));
        tx.appendChild(el('p', 'jp-cm-meta', bits.join(' · ')));
        if (pf.bio) tx.appendChild(el('p', 'jp-cm-cap', pf.bio));
        if (!pf.mine) tx.appendChild(followBtn(pf.key, pf.name));
        hd.appendChild(tx); dlg.appendChild(hd);
        var g = el('div', 'jp-cm-pgrid');
        (pf.posts || []).forEach(function (y) { var b = el('button', 'jp-cm-pi'); b.type = 'button'; b.setAttribute('aria-label', sub(t.open, { title: (y.design && y.design.title) || t.custom_title })); b.appendChild(photoImg(y, '(min-width: 900px) 200px, 33vw')); b.addEventListener('click', function () { dlg.classList.remove('jp-cm-prof'); var hit = all.filter(function (z) { return z.public_key === y.public_key; })[0] || y; show(hit, true); }); g.appendChild(b); });
        if ((pf.designs || []).length) {
          var dh = el('div', 'jp-cm-pdes'); dh.appendChild(el('p', 'jp-cm-sameh', t.in_library));
          var dr = el('div', 'jp-topic-ds');
          pf.designs.forEach(function (dz) { var a = el('a', 'jp-topic-d'); a.href = safeHref(dz.url); var ph = el('b', 'jp-wph'); if (dz.image) ph.appendChild(img(dz.image, '', 112)); a.appendChild(ph); a.appendChild(el('span', '', dz.title || '')); dr.appendChild(a); });
          dh.appendChild(dr); dlg.appendChild(dh);
        }
        dlg.appendChild(g);
        dlg.setAttribute('aria-label', pf.name || '');
        if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); } document.documentElement.classList.add('jp-cm-lock');
        dlg.scrollTop = 0;
        if (push) { lastHash = '#u-' + key; try { history.replaceState(null, '', lastHash); } catch (_) {} }
      });
    }
    /* a sample opened large: the page's sample sheet (Sample by JUSTPRESS, Worn on / Made as / Tested wear, what it
       was made as and how to make the same); the caption is not printed, it says the same */
    function sampleInfo(x, smp, info) {
      var dz = x.design || {}, who = el('p', 'jp-cm-smh');
      who.appendChild(el('b', '', SMP.by + (smp.real ? ' · ' + SMP.real : '')));
      who.appendChild(document.createTextNode([smp.kind, x.placement_label].filter(Boolean).join(' · ')));
      info.appendChild(who);
      var facts = el('div', 'jp-cm-facts');
      [[SMP.worn, x.placement_label], [SMP.made, smp.kind], [SMP.wear_k, smp.wear && sub(SMP.days, { r: smp.wear })]].forEach(function (r) {
        if (!r[1]) return; var dv = el('div', '', r[0]); dv.appendChild(el('b', '', r[1])); facts.appendChild(dv);
      });
      info.appendChild(facts);
      info.appendChild(likeBox(x));
      var acts = el('p', 'jp-cm-acts');
      if (dz.url) {
        var row = el('a', 'jp-cm-design'); row.href = safeHref(dz.url);
        if (dz.image) { var ph = el('b', 'jp-wph'); ph.appendChild(img(dz.image, '', 56)); row.appendChild(ph); }
        row.appendChild(el('b', '', dz.title || smp.title)); info.appendChild(row);
        if (dz.handle) acts.appendChild(setAdd(dz, t, 'cta', t.add)); acts.appendChild(link(dz.url, 'pbtn', t.view));
      } else if (smp.kind === 'Text design') acts.appendChild(link(P.text || P.make || '#', 'cta', SMP.text_cta));
      else if (smp.kind === 'Library design') acts.appendChild(link(P.library || '#', 'cta', SMP.library_cta));
      else acts.appendChild(link(P.make || '#', 'cta', SMP.photo_cta));
      info.appendChild(acts);
    }
    function show(x, push) {
      dlg.classList.remove('jp-cm-prof');
      var dz = x.design || {}, cu = isCustom(x), smp = sampleOf(x); dlg.textContent = '';
      var x0 = el('button', 'jp-cm-x'); x0.type = 'button'; x0.setAttribute('aria-label', t.close); x0.textContent = '×'; x0.addEventListener('click', close); dlg.appendChild(x0);
      var fig = el('div', 'jp-cm-big'); fig.appendChild(photoImg(x, '(min-width: 900px) 560px, 100vw', true)); dlg.appendChild(fig);
      var info = el('div', 'jp-cm-info');
      if (smp) {
        info.appendChild(el('h2', 'jp-cm-st', sub(SMP.title, { t: smp.title })));
        sampleInfo(x, smp, info); sendView(x);
        var cw0 = el('div', 'jp-cm-com'); comments(x, cw0); info.appendChild(cw0);
        dlg.appendChild(info); openPost(x, sub(SMP.title, { t: smp.title }), push);
        return;
      }
      var au = el('p', 'jp-cm-au'); au.appendChild(authorLink(x, 'jp-cm-aun'));
      au.appendChild(el('span', 'jp-cm-src', cu ? t.custom : t.library));
      if (x.published_at) au.appendChild(el('small', '', fmtDate(x.published_at)));
      if (x.author && x.author.key && !x.mine) au.appendChild(followBtn(x.author.key, x.author.name));
      info.appendChild(au);
      diary(x, fig, info);
      if (x.from_order) info.appendChild(el('p', 'jp-cm-meta', t.from_order));
      if (x.caption) info.appendChild(el('p', 'jp-cm-cap', x.caption));
      var meta = []; if (x.placement_label) meta.push(x.placement_label); if (Number.isInteger(x.reported_day)) meta.push(sub(t.day, { d: x.reported_day }));
      if (meta.length) info.appendChild(el('p', 'jp-cm-meta', meta.join(' · ')));
      if (x.incentivized) info.appendChild(el('p', 'jp-ugc-r', t.reward));
      sendView(x);
      info.appendChild(likeBox(x));
      if (cu) {
        info.appendChild(el('p', 'jp-cm-design jp-cm-own', sub(t.custom_by, { name: (x.author && x.author.name) || '' })));
        var ma = el('p', 'jp-cm-acts'); ma.appendChild(link(P.make || '#', 'cta', t.make_own)); info.appendChild(ma);
        if (x.mine) offer(x, info);
      } else {
        if (dz.creator && dz.creator.name) {
          var cr = el('p', 'jp-cm-credit'); cr.appendChild(el('span', '', t.design_by));
          cr.appendChild(authorLink({ author: dz.creator }, 'jp-cm-aun')); info.appendChild(cr);
        }
        var row = el('a', 'jp-cm-design'); row.href = safeHref(dz.url);
        if (dz.image) { var ph = el('b', 'jp-wph'); ph.appendChild(img(dz.image, '', 56)); row.appendChild(ph); }
        row.appendChild(el('b', '', dz.title || '')); info.appendChild(row);
        var acts = el('p', 'jp-cm-acts'); if (dz.handle) acts.appendChild(setAdd(dz, t, 'cta', t.add)); acts.appendChild(link(dz.url, 'pbtn', t.view)); info.appendChild(acts);
        var same = all.filter(function (y) { return y !== x && !isCustom(y) && y.design && String(y.design.id) === String(dz.id); }).slice(0, 6);
        if (same.length) {
          info.appendChild(el('p', 'jp-cm-sameh', t.same));
          var strip = el('div', 'jp-cm-same');
          same.forEach(function (y) { var b = el('button', 'jp-cm-sm'); b.type = 'button'; b.setAttribute('aria-label', sub(t.open, { title: dz.title || '' })); b.appendChild(photoImg(y, '96px')); b.addEventListener('click', function () { show(y, true); }); strip.appendChild(b); });
          info.appendChild(strip);
        }
      }
      var cw = el('div', 'jp-cm-com'); comments(x, cw); info.appendChild(cw);
      dlg.appendChild(info);
      openPost(x, cu ? t.custom_title : (dz.title || ''), push);
    }
    function openPost(x, label, push) {
      dlg.setAttribute('aria-label', label);
      if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); } document.documentElement.classList.add('jp-cm-lock');
      dlg.scrollTop = 0;
      if (push || x.page_url) { lastHash = x.page_url || '#p-' + x.public_key; addr(lastHash); }
    }
    function close() {
      if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
    }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('jp-cm-lock'); if (lastHash && (location.hash === lastHash || location.pathname === lastHash)) { addr(home); lastHash = ''; } });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    /* scrolling loads more; a button only where IntersectionObserver is missing */
    var io = null;
    if ('IntersectionObserver' in window) { io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) loadMore(); }, { rootMargin: '600px 0px' }); io.observe(end); }
    more.addEventListener('click', loadMore);
    var rz = 0; window.addEventListener('resize', function () { if (rz) return; rz = requestAnimationFrame(function () { rz = 0; var n = ncols(); if (n !== cols.length) { var k = shown; build(); shown = 0; var list = all.filter(match).slice(0, k); list.forEach(place); shown = list.length; } }); });
    chips(); draw(true);
    function fromHash() {
      var tk = /^#([a-z][a-z0-9-]*)$/.exec(location.hash);
      if (tk && topicRow && topicRow.querySelector('[data-t="' + tk[1] + '"]')) { topic = tk[1] === 'all' ? '' : tk[1]; paintTopics(); draw(true); return; }
      var u = /^#u-(.+)$/.exec(location.hash);
      if (u) { lastHash = location.hash; showProfile(decodeURIComponent(u[1]), false); return; }
      var m = /^#p-(.+)$/.exec(location.hash);
      if (!m) return;
      var hit = all.filter(function (x) { return String(x.public_key) === decodeURIComponent(m[1]); })[0];
      if (hit) { lastHash = location.hash; show(hit, false); }
    }
    window.addEventListener('hashchange', fromHash);
    /* step 2: the Following tab - posts from people you follow */
    var fwBox = document.querySelector('[data-comm-following]'), fwDone = false;
    function following() {
      if (!fwBox || fwDone) return; fwDone = true;
      if (!me) { var p0 = el('p', 'jp-photos-empty'); p0.appendChild(signLink(t.sign_following)); fwBox.appendChild(p0); return; }
      loadFollows().then(function (fd) {
        var items = fd && fd.items || [];
        if (!items.length) { fwBox.appendChild(el('p', 'jp-photos-empty', t.following_none)); return; }
        var w = el('div', 'jp-photos-feed'), wl = el('div', 'jp-cm-wall'); w.appendChild(wl); fwBox.appendChild(w);
        var n = ncols(), cs = [], hs = [];
        for (var i = 0; i < n; i++) { var c = el('div', 'jp-cm-col'); wl.appendChild(c); cs.push(c); hs.push(0); }
        items.forEach(function (x) { var hit = all.filter(function (z) { return z.public_key === x.public_key; })[0] || x; if (all.indexOf(hit) < 0) all.push(hit); var k = 0; for (var j = 1; j < hs.length; j++) if (hs[j] < hs[k] - 1) k = j; cs[k].appendChild(tile(hit)); hs[k] += (hit.image_w && hit.image_h ? hit.image_h / hit.image_w : 1.25) + 0.18; });
      });
    }
    document.addEventListener('justpress:comm-tab', function (e) { if (e.detail === 'following') following(); });
    document.addEventListener('justpress:follow', function () { if (fwBox && fwDone) { fwDone = false; followsReady = null; fwBox.textContent = ''; } });
    fromHash();
  } };

  /* ---------- signed-in modules (T19–T22, T27, T28): our own service, through the App Proxy ---------- */
  var M = (function () { var n = document.querySelector('[data-jp-mod-t]'); return n ? json(n.textContent) : {}; })();
  var cfg = window.jpData || {};

  /* T19: saved designs that have customer photos */
  R['saved-ugc'] = { kind: 'ugc_index', fill: function (root, d) {
    var ids = {}; d.product_ids.forEach(function (x) { ids[String(x)] = 1; });
    function mark() {
      document.querySelectorAll('[data-jp-saved-card]').forEach(function (c) {
        if (!ids[c.getAttribute('data-product-id')] || c.querySelector('.jp-svugc')) return;
        var a = c.querySelector('a'); if (!a) return;
        c.appendChild(link(a.getAttribute('href') + '#photos', 'jp-svugc', M.ugc_saved));
      });
    }
    mark(); var g = document.querySelector('[data-jp-saved-grid]'); if (g && window.MutationObserver) new MutationObserver(mark).observe(g, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  } };

  /* T22: the photo form, as the PROTO-2 Community share sheet (owner 11/03): photo (required), where it is and which
     day (optional chips, one each), a rating (optional, nothing chosen until the customer picks; a rated photo is also
     a Judge.me review of the design), a comment (optional), the notice, the 18+ / rules box. Sent fields: photo,
     placement, wear_day, rating (only when chosen), comment, plus the unit and the consent flags as before.
     placement and wear_day are sent as the backend contract spells them (the chips show the locale's labels). */
  var SPOTS = ['Wrist', 'Forearm', 'Upper arm', 'Chest', 'Ankle', 'Back', 'Other'];
  var DAYS = ['Day 1', 'Day 2–3', 'Day 4–7', 'Day 8+'];
  var STAR_SVG = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="currentColor" d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.8l-5.2 2.8 1-5.8L3.5 9.7l5.9-.8z"/></svg>';
  /* one optional choice from a row of chips: tap to pick, tap the picked one again to clear */
  function chipPick(legend, values, labels, cls) {
    var fs = el('fieldset', 'jp-shf-c ' + (cls || '')), val = '';
    fs.appendChild(el('legend', '', legend));
    var row = el('div', 'jp-shf-cr'); fs.appendChild(row);
    var bs = values.map(function (v, k) {
      var b = el('button', '', labels[k] || v); b.type = 'button'; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { val = val === v ? '' : v; bs.forEach(function (x, j) { x.setAttribute('aria-pressed', String(values[j] === val)); }); });
      row.appendChild(b); return b;
    });
    fs.value = function () { return val; };
    fs.clear = function () { val = ''; bs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); };
    return fs;
  }
  function shareForm(unit, done) {
    var f = el('form', 'jp-shf'); f.noValidate = true;
    var st = el('p', 'jp-shf-st cap2'); st.setAttribute('role', 'status');
    f.appendChild(el('b', '', M.form_h));
    /* the photo picker is our own tile: the browser's file button speaks the visitor's system language and style */
    var ph = el('div', 'jp-shf-f'); ph.appendChild(el('span', '', M.form_photo));
    var pk = el('label', 'jp-shf-pk'); var fi = el('input'); fi.type = 'file'; fi.name = 'photo'; fi.accept = 'image/jpeg,image/png,image/webp'; fi.className = 'jp-shf-in';
    var pv = el('span', 'jp-shf-pv'); pv.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="3"/><circle cx="12" cy="12" r="3.5"/><path d="M8 5l1.5-2h5L16 5"/></svg>';
    var pt = el('span', 'jp-shf-pt'); var pa = el('b', '', M.form_photo_add); var phn = el('small', '', M.form_photo_hint); pt.appendChild(pa); pt.appendChild(phn);
    pk.appendChild(fi); pk.appendChild(pv); pk.appendChild(pt); ph.appendChild(pk); f.appendChild(ph);
    fi.addEventListener('change', function () {
      var file = fi.files && fi.files[0]; st.textContent = '';
      if (!file) { pk.classList.remove('is-set'); pv.style.backgroundImage = ''; pa.textContent = M.form_photo_add; phn.textContent = M.form_photo_hint; return; }
      if (file.size > 15 * 1024 * 1024) { fi.value = ''; pk.classList.remove('is-set'); pv.style.backgroundImage = ''; pa.textContent = M.form_photo_add; phn.textContent = M.form_photo_hint; st.textContent = M.form_photo_big; return; }
      pk.classList.add('is-set'); pa.textContent = file.name; phn.textContent = M.form_photo_change;
      try { var u = URL.createObjectURL(file); pv.style.backgroundImage = 'url("' + u + '")'; } catch (_) {}
    });
    var where = chipPick(M.form_where, SPOTS, String(M.form_spots || '').split('|')); f.appendChild(where);
    var day = chipPick(M.form_day, DAYS, String(M.form_days || '').split('|')); f.appendChild(day);
    /* rating: five stars, none chosen; the chosen star again clears it */
    var rate = 0, rf = el('fieldset', 'jp-shf-c jp-shf-rt'); rf.appendChild(el('legend', '', M.form_rating));
    rf.appendChild(el('p', '', M.form_rating_note));
    var srow = el('div', 'jp-shf-stars'); rf.appendChild(srow);
    var stars = [1, 2, 3, 4, 5].map(function (n) {
      var b = el('button'); b.type = 'button'; b.innerHTML = STAR_SVG; b.setAttribute('aria-label', sub(n === 1 ? M.form_star_one : M.form_star_other, { n: n })); b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { setRate(rate === n ? 0 : n); });
      srow.appendChild(b); return b;
    });
    var clr = el('button', 'jp-shf-clr', M.form_rating_clear); clr.type = 'button'; clr.hidden = true; clr.addEventListener('click', function () { setRate(0); }); srow.appendChild(clr);
    function setRate(n) { rate = n; stars.forEach(function (b, k) { b.classList.toggle('on', k < n); b.setAttribute('aria-pressed', String(k + 1 === n)); }); clr.hidden = !n; }
    f.appendChild(rf);
    var cm = el('label', 'jp-shf-f'); cm.appendChild(el('span', '', M.form_comment)); var ta = el('textarea'); ta.name = 'comment'; ta.rows = 3; ta.maxLength = 400; ta.placeholder = M.form_comment_ph || ''; cm.appendChild(ta); f.appendChild(cm);
    f.appendChild(el('p', 'jp-shf-note', M.form_notice));
    /* control centre 11.2: one box the first time someone posts (18+ and the posting rules); hidden once their profile
       says they agreed (my_profile.rules_agreed) */
    var ag = el('label', 'jp-cm-tick'); var agc = el('input'); agc.type = 'checkbox'; ag.appendChild(agc);
    var ags = el('span', '', M.form_age + ' '); if (M.rules_url) ags.appendChild(link(M.rules_url, 'lnk', M.form_rules)); ag.appendChild(ags); f.appendChild(ag);
    window.JPData.get('my_profile', {}).then(function (p) { if (p && p.rules_agreed === true) { agc.checked = true; ag.hidden = true; } });
    var b = el('button', 'cta', M.form_send); b.type = 'submit'; f.appendChild(b); f.appendChild(st);
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!(fi.files && fi.files[0])) { st.textContent = M.form_photo_need; return; }
      if (!agc.checked) { st.textContent = M.form_age_need; return; }
      if (window.JPProto && window.JPProto.__submit) { window.JPProto.__submit(st); return; }
      if (!cfg.me) return;
      var fd = new FormData(f); fd.append('purchased_unit_id', unit.unit_id); fd.append('design_id', unit.design_id); fd.append('age_confirmed', '1'); fd.append('rules_agreed', '1');
      if (where.value()) fd.append('placement', where.value());
      if (day.value()) fd.append('wear_day', day.value());
      if (rate) fd.append('rating', String(rate));
      b.disabled = true;
      fetch(cfg.me.replace(/\/$/, '') + '/v1/me/submissions', { method: 'POST', credentials: 'same-origin', body: fd })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { if (!res.ok || j.ok === false) throw new Error(j.code || ''); }); })
        .then(function () { f.reset(); fi.dispatchEvent(new Event('change')); where.clear(); day.clear(); setRate(0); st.textContent = M.form_sent; if (done) done(); })
        .catch(function () { st.textContent = M.form_error; }).then(function () { b.disabled = false; });
    });
    return f;
  }

  /* "1 set", "2 sets": the count's own word, from the locale's one/other strings */
  function plural(n, one, other) { return sub(n === 1 ? one : other, { n: n }); }
  /* a design's picture; a design without one (custom and upload designs: purchased/1 carries no image for them) or
     with one that fails to load gets a drawn placeholder, never an empty box */
  var PH_SVG = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 3.5l2.2 4.9 5.3.6-4 3.6 1.1 5.2L12 15.2l-4.6 2.6 1.1-5.2-4-3.6 5.3-.6z"/></svg>';
  function thumb(src) {
    var ph = el('span', 'jp-pur-ph'); ph.innerHTML = PH_SVG;
    if (!src) return ph;
    var i = img(src, '', 72); i.addEventListener('error', function () { i.replaceWith(ph); }); return i;
  }

  /* T20: Purchased, one row per design × size */
  R['purchased'] = { kind: 'purchased', fill: function (root, d, t, tpl) {
    /* rows the page can show: each needs the design's name and link (D06); without them the module stays out and the
       order-based list below keeps the panel */
    var items = (d.items || []).filter(function (u) { return u && u.design && u.design.title && (u.design.url || u.design.url === null); });
    if (!items.length) return false;
    var c = root.querySelector('[data-slot-c]');
    if (Number.isInteger(d.sets_count) && Number.isInteger(d.units_count)) c.textContent = sub(M.purch_counts, { sets: plural(d.sets_count, M.purch_set_one, M.purch_set_other), units: plural(d.units_count, M.purch_design_one, M.purch_design_other) }); else c.hidden = true;
    var ul = root.querySelector('[data-slot]');
    /* one list only: the service knows older orders too, so it replaces the order-based grid, its empty note and its count */
    var panel = tpl && tpl.closest('[data-jp-saved-panel="purchased"]');
    if (panel) {
      panel.querySelectorAll('.jp-saved-page__grid--purchased, .jp-saved-page__empty').forEach(function (n) { n.hidden = true; n.style.display = 'none'; });
      var tot = document.querySelector('[data-jp-purchased-total]'); if (tot) tot.textContent = String(Number.isInteger(d.units_count) ? d.units_count : items.length);
    }
    items.forEach(function (u) {
      var li = el('li', 'jp-pur-i'), dz = u.design || {};
      var a = dz.url ? link(dz.url, 'jp-pur-a') : el('div', 'jp-pur-a'); a.appendChild(thumb(dz.image));
      var tx = el('span', 'jp-pur-tx'); tx.appendChild(el('b', '', dz.title || ''));
      var meta = [String(u.size_label || '').replace(/ IN$/i, ' in') + (u.qty > 1 ? ' · ×' + u.qty : '')];
      if (u.ordered_at && fmtDate(u.ordered_at)) meta.push(sub(M.purch_ordered, { date: fmtDate(u.ordered_at) }));
      tx.appendChild(el('small', '', meta.filter(Boolean).join(' · ')));
      var rw = { eligible: M.rw_eligible, pending: M.rw_pending, granted: M.rw_granted }[u.reward_state];
      var rwEl = rw ? el('small', 'jp-pur-rw', rw) : null;
      if (rwEl) { if (u.reward_state === 'eligible') rwEl.hidden = true; tx.appendChild(rwEl); }
      a.appendChild(tx); li.appendChild(a);
      if (u.reward_state === 'eligible') {
        var sb = el('button', 'pbtn jp-pur-sh', M.purch_share); sb.type = 'button'; sb.hidden = true;
        sb.addEventListener('click', function () {
          if (li.querySelector('form')) return;
          var f = shareForm(u); li.appendChild(f); sb.hidden = true;
          var h = f.querySelector('b'); h.tabIndex = -1; h.focus({ preventScroll: true });
          f.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
        li.appendChild(sb);
        /* posting opens with the programme: the button appears only while /v1/program says running */
        window.JPData.get('program', {}).then(function (pg) { if (!pg) return; if (rwEl) rwEl.hidden = false; if (!li.querySelector('form')) sb.hidden = false; });
      }
      ul.appendChild(li);
    });
    if (d.state === 'partial' || d.next_cursor) { var m = root.querySelector('[data-slot-more]'); m.textContent = sub(M.purch_more, { n: d.items.length }); m.hidden = false; }
  } };

  /* T22: photos already sent, their own four states, and the takedown request */
  R['submissions'] = { kind: 'submissions', fill: function (root, d) {
    var ul = root.querySelector('[data-slot]');
    d.items.forEach(function (x) {
      var li = el('li', 'jp-sub-i'), dz = x.design || {};
      li.appendChild(thumb(dz.image));
      var tx = el('span', 'jp-sub-tx'); tx.appendChild(el('b', '', dz.title || ''));
      /* the photo's state as a chip; the reward line only when it adds something ("being checked" is the chip's) */
      var ms = { pending: M.sub_pending, approved: M.sub_approved, rejected: M.sub_rejected }[x.media_status];
      if (ms) tx.appendChild(el('span', 'jp-chip jp-chip--' + x.media_status, ms));
      var bits = [];
      if (x.submitted_at && fmtDate(x.submitted_at)) bits.push(sub(M.sub_sent, { date: fmtDate(x.submitted_at) }));
      if (x.reward_status === 'granted') bits.push(M.rw_granted);
      if (bits.length) tx.appendChild(el('small', '', bits.join(' · ')));
      li.appendChild(tx);
      if (x.withdrawal_status === 'none' && x.display_permission === 'active') {
        var b = el('button', 'lnk', M.sub_withdraw); b.type = 'button';
        b.addEventListener('click', function () {
          if (window.JPProto && window.JPProto.__withdraw) { b.replaceWith(el('small', 'cap2', window.JPProto.__withdraw(M.sub_withdrawn))); return; }
          if (!cfg.me) return;
          fetch(cfg.me.replace(/\/$/, '') + '/v1/me/submissions/' + encodeURIComponent(x.submission_id) + '/withdraw', { method: 'POST', credentials: 'same-origin' })
            .then(function (r) { if (r.ok) b.replaceWith(el('small', 'cap2', M.sub_withdrawn)); });
        });
        li.appendChild(b);
      } else if (x.withdrawal_status !== 'none') li.appendChild(el('small', 'cap2', M.sub_withdrawn));
      ul.appendChild(li);
    });
  } };

  /* T21: balance in Your Library (balance/2, 10/16: gift spaces were dropped, only paid spaces remain) */
  R['balance'] = { kind: 'balance', fill: function (root, d) {
    root.querySelector('[data-slot]').textContent = sub(M.bal_line_paid, { total: d.total_available });
    if (d.paid_held) { var h = root.querySelector('[data-slot-held]'); h.textContent = sub(M.bal_held, { n: d.paid_held }); h.hidden = false; }
    var ul = root.querySelector('[data-slot-hist]'), hist = (d.history || []).filter(function (x) { return x && Number.isInteger(x.spaces) && x.spaces >= 0; }).slice(0, 20);
    if (!hist.length) { root.querySelector('.jp-bal-hist').remove(); return; }
    hist.forEach(function (x) { var li = el('li'); li.appendChild(el('span', '', M['hk_' + x.kind] || x.kind)); li.appendChild(el('b', '', (/spend|hold/.test(x.kind) ? '−' : '+') + x.spaces)); li.appendChild(el('small', '', fmtDate(x.effective_at))); ul.appendChild(li); });
  } };
  /* T27 / T28: one line on Start and in the cart */
  R['balance-hint'] = { kind: 'balance', fill: function (root, d) {
    if (!d.total_available) { root.hidden = true; return; }
    root.textContent = sub(M.hint_line_paid, { total: d.total_available });
  } };
  /* 10/15 long-term programme: an approved photo review makes every design in the next order print twice */
  function until(d) { return d.expires_at ? ' ' + sub(M.reward_until, { date: fmtDate(d.expires_at) }) : ''; }
  R['reward'] = { kind: 'reward', fill: function (root, d) { root.querySelector('[data-slot]').textContent = M.reward_line + until(d); } };
  R['reward-hint'] = { kind: 'reward', fill: function (root, d) { root.textContent = M.reward_hint + until(d); } };
  /* T25: the photo-review programme explainer, only while the programme runs */
  R['program'] = { kind: 'program', fill: function () {} };
  /* control centre 11.3 (10/16): rules appear together with the feature they describe. "feature" shows its content
     only when /v1/program lists that feature; "rank-gate" only when the overall most-saved list has something to show. */
  R['feature'] = { kind: 'program', fill: function (root, d, t, tpl) { return (d.features || []).indexOf(json(tpl.getAttribute('data-p')).f) >= 0; } };
  R['rank-gate'] = { kind: 'site_rank', fill: function () {} };

  function mount(tpl) {
    if (tpl.__jp) return; tpl.__jp = true;
    var name = tpl.getAttribute('data-jp-mod'), r = R[name];
    if (!r || !window.JPData) return;
    var params = json(tpl.getAttribute('data-p')), t = json(tpl.getAttribute('data-t'));
    if (r.params) params = r.params(params, tpl);
    window.JPData.get(r.kind, params).then(function (d) {
      if (!d) return;
      /* importNode, not content.cloneNode: a clone of template content belongs to the template's inert document, so
         the pictures a module adds would be created there (no browsing context; lazy loading is not set up) */
      var frag = document.importNode(tpl.content, true);
      var root = frag.firstElementChild;
      if (!root) return;
      if (d.demo) root.setAttribute('data-jp-demo', '');
      if (r.fill(root, d, t, tpl) === false) return;
      tpl.parentNode.insertBefore(frag, tpl);
      /* a link like /pages/faq#how-lists-work whose target is inside a module that just arrived */
      var h = location.hash.slice(1);
      if (h && /^[\w-]+$/.test(h) && (root.id === h || root.querySelector('[id="' + h + '"]'))) document.getElementById(h).scrollIntoView();
      if (!d.demo) document.dispatchEvent(new CustomEvent('justpress:module', { detail: { name: name } }));
    });
  }
  function scan() { document.querySelectorAll('template[data-jp-mod]').forEach(mount); gates(); }
  /* 2.4.14: rules that used to be inert templates are now in the page HTML (crawlers read them) and are hidden here
     when /v1/program does not run them: data-jp-gate="program" or the feature name ("views", "offers"). */
  function gates() {
    var gs = document.querySelectorAll('[data-jp-gate]:not([data-jp-gated])'); if (!gs.length || !window.JPData) return;
    gs.forEach(function (g) { g.setAttribute('data-jp-gated', ''); });
    window.JPData.get('program', {}).then(function (pg) {
      gs.forEach(function (g) { var f = g.getAttribute('data-jp-gate'); var ok = !!pg && (f === 'program' || (pg.features || []).indexOf(f) >= 0); if (!ok) g.hidden = true; });
    }, function () {});
  }
  window.JPModules = { register: function (name, def) { R[name] = def; }, scan: scan, util: { el: el, img: img, link: link, sub: sub, fmtDate: fmtDate, json: json } };
  /* step 2: [data-jp-follow] buttons outside Community (designer page) */
  function followButtons() {
    var bs = document.querySelectorAll('[data-jp-follow]'); if (!bs.length || !window.JPData) return;
    var me = !!(cfg && cfg.customer), follows = {};
    var ready = me ? window.JPData.get('following', {}).then(function (fd) { (fd && fd.follows || []).forEach(function (k) { follows[k] = 1; }); }) : Promise.resolve();
    bs.forEach(function (b) {
      var key = b.getAttribute('data-jp-follow');
      function paint() { var on = !!follows[key]; b.textContent = on ? b.getAttribute('data-t-on') : b.getAttribute('data-t-off'); b.setAttribute('aria-pressed', String(on)); b.classList.toggle('on', on); }
      b.addEventListener('click', function () {
        if (!me) { var a = link(b.getAttribute('data-acct') || '/account', 'lnk', b.getAttribute('data-t-sign')); a.setAttribute('data-jp-account-return', ''); b.replaceWith(a); return; }
        var on = !follows[key]; if (on) follows[key] = 1; else delete follows[key]; paint();
        if (window.JPProto && window.JPProto.__follow) { window.JPProto.__follow(key, on); return; }
        if (cfg.me) fetch(cfg.me.replace(/\/$/, '') + '/v1/me/follows/' + encodeURIComponent(key), { method: on ? 'PUT' : 'DELETE', credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(); }).catch(function () { if (on) delete follows[key]; else follows[key] = 1; paint(); });
      });
      b.hidden = false; paint(); ready.then(paint);
    });
  }
  /* step 2: Community profile settings on the account page (public is off until the customer turns it on) */
  R['my-profile'] = { kind: 'my_profile', fill: function (root, d, t) {
    var cb = root.querySelector('input[type=checkbox]'), nm = root.querySelector('input[type=text]'), st = root.querySelector('[data-slot-st]'), view = root.querySelector('[data-slot-view]');
    cb.checked = !!d.public; nm.value = d.name || '';
    var avBox = root.querySelector('[data-slot-av]'), fi = root.querySelector('input[type=file]'), pick = '';
    function av() { avBox.textContent = ''; avBox.appendChild(avatar({ name: nm.value || d.name, key: d.key, avatar_url: pick || d.avatar_url }, 56)); }
    av(); nm.addEventListener('input', av);
    fi.addEventListener('change', function () { var f = fi.files && fi.files[0]; if (!f) return; var r = new FileReader(); r.onload = function () { pick = String(r.result); av(); }; r.readAsDataURL(f); });
    function v() { view.hidden = !(cb.checked && d.key); if (d.key) view.href = (view.getAttribute('data-base') || '') + '#u-' + encodeURIComponent(d.key); }
    cb.addEventListener('change', v); v();
    root.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var name = nm.value.trim();
      if (!name && cb.checked) { st.textContent = t.need_name; return; }
      if (window.JPProto && window.JPProto.__profile) { st.textContent = window.JPProto.__profile(); return; }
      if (!cfg.me) return;
      var body = new FormData(); body.append('public', cb.checked ? '1' : '0'); body.append('name', name); if (fi.files && fi.files[0]) body.append('avatar', fi.files[0]);
      fetch(cfg.me.replace(/\/$/, '') + '/v1/me/profile', { method: 'PUT', credentials: 'same-origin', body: body })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { st.textContent = r.ok && j.ok !== false ? t.saved : t.error; }); }).catch(function () { st.textContent = t.error; });
    });
  } };
  /* views (10/16): the customer's own posts with views, likes and comments - always their true numbers */
  R['my-posts'] = { kind: 'my_posts', fill: function (root, d, t) {
    var ul = root.querySelector('[data-slot]');
    d.items.forEach(function (x) {
      var li = el('li', 'jp-mypo-i');
      var a = link((root.getAttribute('data-base') || '') + '#p-' + encodeURIComponent(x.public_key), 'jp-mypo-a');
      var ph = el('b', 'jp-mypo-ph'); if (x.image_url) ph.appendChild(img(x.image_url, '', 112)); a.appendChild(ph);
      var tx = el('span', 'jp-mypo-tx');
      tx.appendChild(el('b', '', x.title || ''));
      tx.appendChild(el('small', '', [sub(t.views, { n: fmtN(Number(x.view_count) || 0) }), sub(t.likes, { n: Number(x.like_count) || 0 }), sub(t.comments, { n: Number(x.comment_count) || 0 })].join(' · ')));
      a.appendChild(tx); li.appendChild(a); ul.appendChild(li);
    });
  } };
  /* step 3: the customer's offered designs and where each one stands */
  R['my-designs'] = { kind: 'my_designs', fill: function (root, d, t) {
    var ul = root.querySelector('[data-slot]');
    d.items.forEach(function (x) {
      var li = el('li', 'jp-myd-i');
      var ph = el('b', 'jp-wph'); if (x.image) ph.appendChild(img(x.image, '', 56)); li.appendChild(ph);
      var tx = el('span', 'jp-myd-tx'); tx.appendChild(el('b', '', x.name || t.untitled)); tx.appendChild(el('small', '', t['st_' + x.state] || x.state));
      if (x.state === 'listed' && x.url) { var a = link(x.url, 'lnk', t.view); tx.appendChild(a); }
      li.appendChild(tx); ul.appendChild(li);
    });
  } };
  function start() { scan(); startSets(); costLine(); followButtons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
